  import {
    GASTOS_GUARDAR_REQUEST,
  } from '../constants/caja.creador.constants';

  export const guardarGastos = () => ({
    type: GASTOS_GUARDAR_REQUEST,
  });
